import _ from 'lodash';
import React from 'react';
import { useFormikContext } from 'formik';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import FormGroup from '~/commons/components/FormGroup.jsx';
import FormCheckGroup from '~/commons/components/FormCheckGroup.jsx';
import { faDownload } from '@fortawesome/free-solid-svg-icons/faDownload';
import { faLink } from '@fortawesome/free-solid-svg-icons/faLink';
import useComparable from '~/commons/hooks/useComparable';

import { env } from '~/commons/config';

function FieldAr({ values, setValues }) {
  const designId = values?.design?.id ?? values?.design?._id;
  const variantCode = values.designVariantCode ? values.designVariantCode : null;
  const variantIdx = designId && variantCode ? _.findIndex(values?.design?.variation, (v) => v.itemCode === variantCode) : -1;
  const arImg = variantIdx === -1 || !values?.arInherit ? values?.arImg : values?.design?.variation?.[variantIdx]?.arImg;
  const arModel = variantIdx === -1 || !values?.arInherit ? values?.arModel : values?.design?.variation?.[variantIdx]?.arModel;

  return (
    <>
      <h6 className="small border-bottom text-muted py-1 pt-4 mb-3">AR</h6>
      <div className="row">
        <div className="col-auto d-flex align-items-center">
          <label>AR</label>
          <div className="ml-2">
            <FormCheckGroup
              name={variantIdx === -1 || !values.arInherit ? 'arActive' : 'design.arActive'}
              type="checkbox"
              label=""
              asSwitch
              disabled={variantIdx !== -1 && values.arInherit}
            />
          </div>
        </div>
        <FormGroup
          label="Variant Item Code"
          name="designVariantCode"
          as="select"
          onChange={(e) => {
            setValues((v) => ({
              ...v,
              designVariantCode: e.target.value,
              ...(v.inherit
                ? {
                  style: (v.design.style || []).join(','),
                  color: (v.design.color || []).join(','),
                  shape: (v.design.shape || []).join(','),
                  description: v.design.description,
                }
                : {}),
            }));
          }}
        >
          <option value=""> - </option>
          {_.filter(values?.design?.variation, (v) => !_.isEmpty(v.itemCode)).map((v) => (
            <option value={v.itemCode} key={v.itemCode}>{v.itemCode}</option>
          ))}
        </FormGroup>
        {designId && variantCode && <>
          <div className="col-auto d-flex align-items-center">
            <label>Inherit</label>
            <div className="ml-2">
              <FormCheckGroup
                name="arInherit"
                type="checkbox"
                label=""
                asSwitch
              />
            </div>
          </div>
          <div className="col-auto">
            <a
              className="btn"
              target='_blank'
              rel="noreferrer"
              href={`/admin/designs/items/${designId}/edit?tab=variants#${variantCode}`}
            >
              <FA icon={faLink} fixedWidth />
            </a>
          </div>
        </>}
      </div>
      <div className="row">
        <div className="col">
          <FormGroup
            key={variantIdx === -1 || !values.arInherit ? 'arImg' : `design.variation.${variantIdx}.arImg`}
            name={variantIdx === -1 || !values.arInherit ? 'arImg' : `design.variation.${variantIdx}.arImg`}
            as="coverImg"
            api="/api/core/designs/files"
            label="AR Image"
            disabled={variantIdx !== -1 && values.arInherit}
          />
        </div>
        <div className="col">
          <FormGroup
            name={variantIdx === -1 || !values.arInherit ? 'arModel' : `design.variation.${variantIdx}.arModel`}
            label="AR Model"
            as="select"
            disabled={variantIdx !== -1 && values.arInherit}
          >
            <option value=""> - </option>
            {env.arModels.map((v) => (
              <option value={v} key={v}>{v}</option>
            ))}
          </FormGroup>
        </div>
        <div className="col">
          {arImg && arModel && (
            <div className="form-group">
              <label>AR Download</label>
              <div>
                <a
                  className="btn btn-secondary mr-2"
                  href={`/api/core/arModels/${arModel}/${_.trim(arImg, '/').replace('uploads/', '')}/result.usdz`}
                >
                  <FA icon={faDownload} fixedWidth />
                </a>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default () => {
  const { status, setValues, values } = useFormikContext();
  return React.useMemo(() => FieldAr({ status, setValues, values }), [useComparable(values)]);
};
